import { Timestamp } from 'firebase/firestore';

export interface Currency {
  code: string;        // EUR, USD, GBP, etc.
  symbol: string;      // €, $, £, etc.
  name: string;        // Euro, US Dollar, British Pound
  position: 'before' | 'after';  // Position du symbole
  decimalSeparator: string;     // ',' ou '.'
  thousandsSeparator: string;   // ' ' ou ','
  decimalDigits: number;        // Nombre de décimales à afficher
}

export interface OrganizationCurrencySettings {
  defaultCurrency: string;
  decimalSeparator: string;
  thousandsSeparator: string;
  symbolPosition: 'before' | 'after';
}

// Liste des devises supportées
export const SUPPORTED_CURRENCIES: Currency[] = [
  {
    code: 'EUR',
    symbol: '€',
    name: 'Euro',
    position: 'after',
    decimalSeparator: ',',
    thousandsSeparator: ' ',
    decimalDigits: 2
  },
  {
    code: 'USD',
    symbol: '$',
    name: 'US Dollar',
    position: 'before',
    decimalSeparator: '.',
    thousandsSeparator: ',',
    decimalDigits: 2
  },
  {
    code: 'GBP',
    symbol: '£',
    name: 'British Pound',
    position: 'before',
    decimalSeparator: '.',
    thousandsSeparator: ',',
    decimalDigits: 2
  }
];

// Fonction utilitaire pour formater les montants
export const formatCurrency = (
  amount: number,
  settings: OrganizationCurrencySettings
): string => {
  const currency = SUPPORTED_CURRENCIES.find(c => c.code === settings.defaultCurrency);
  if (!currency) {
    throw new Error(`Currency not found: ${settings.defaultCurrency}`);
  }

  const formattedNumber = amount.toFixed(2)
    .replace('.', settings.decimalSeparator)
    .replace(/\B(?=(\d{3})+(?!\d))/g, settings.thousandsSeparator);

  return settings.symbolPosition === 'before'
    ? `${currency.symbol}${formattedNumber}`
    : `${formattedNumber}${currency.symbol}`;
};